<template>
  <div class="flex h-screen flex-col">
    <div class="flex h-full w-full flex-col px-10">
      <slot />
    </div>
    <div id="modalContainer" ref="modalContainer" />
  </div>
</template>

<style>
body {
  @apply bg-slate-100;
  overscroll-behavior: none;
}

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background: #d1d5db;
  border-radius: 5px;
}

::-webkit-scrollbar-thumb {
  background: #6b7280;
  border-radius: 5px;
}

::-webkit-scrollbar-thumb:hover {
  background: #4b5563;
}
</style>
